import React from "react";
import * as XLSX from "xlsx";
import PropTypes from "prop-types";
import { generateRandomUUID as randomUuid } from "../utils/helpers";
import { today } from "../utils/dateHelpers";
import { RENAME_FIELDS_EXCELL as columnsRename } from "../utils/globals";
import * as RiIcons from "react-icons/ri";
const _ButtonExportExcel = ({
  dataReport = [],
  fileName = "Reporte",
  label = "Exportar",
}) => {
  const handleExport = (data) => {
    const file_name = `${fileName}_${today()}_${randomUuid()}.xlsx`;

    const items = renameColumns(data);

    const worksheet = XLSX.utils.json_to_sheet(items);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, file_name);
  };

  const renameColumns = (data = []) => {
    if (!data.length) {
      return [];
    }

    return data.map((row) => {
      const renamed = {};

      for (const key in row) {
        const newKey = columnsRename[key] || key;
        renamed[newKey] = row[key];
      }

      return renamed;
    });
  };

  return (
    <div>
      <button
        className="border-none flex-1 text-blue-500 text-sm py-2 px-3 rounded-lg hover:bg-blue-500 hover:text-white"
        onClick={() => handleExport(dataReport)}
      >
        <RiIcons.RiFileExcel2Line /> {label && label}
      </button>
    </div>
  );
};

export default _ButtonExportExcel;

_ButtonExportExcel.propTypes = {
  dataReport: PropTypes.array,
  fileName: PropTypes.string,
  label: PropTypes.string,
};
